import * as React from "react";
import classNames from "classnames";
import { MediaQuery, Util, Image, Button } from "@grandvisionhq/common";
import { BannerTooltip } from "@grandvisionhq/content";
import { Heading, Text } from "@grandvisionhq/elements";
import { isDefined } from "@grandvisionhq/utils";
/* empty css                    */
const ClickableImageWrapper = ({ url, children, ctaLabel, ariaLabel, tabIndex }) => {
  const sharedProps = {
    className: "promotion-block__link",
    "data-t": "promotion-block-image"
  };
  if (!url) {
    return /* @__PURE__ */ React.createElement("div", { ...sharedProps }, children);
  }
  let linkTabIndex = void 0;
  if (isDefined(tabIndex)) {
    linkTabIndex = tabIndex;
  } else if (ctaLabel) {
    linkTabIndex = -1;
  }
  return /* @__PURE__ */ React.createElement(
    "a",
    {
      href: url,
      tabIndex: linkTabIndex,
      "aria-hidden": ctaLabel ? "true" : void 0,
      "aria-label": ctaLabel ? void 0 : ariaLabel,
      ...sharedProps
    },
    children
  );
};
const PromotionBlock = React.forwardRef(
  ({
    id,
    title,
    description,
    image,
    links,
    size,
    onClick,
    ctaLabel,
    manageContentButton,
    tooltip,
    className,
    tabIndex
  }, ref) => {
    const imageUrl = MediaQuery.useIsPhone() ? image?.mobileUrl : image?.url;
    if (!imageUrl) {
      return null;
    }
    const buttonStyles = links?.style ? Util.createButtonStyles(links.style) : {};
    const classNames$1 = classNames("promotion-block", className, {
      "promotion-block--overlay": !!title || !!description,
      "promotion-block--large": size === "large",
      "promotion-block--without-text": !title || !description
    });
    const promotionInfoId = `promotion-info-${id}`;
    const { url, alt } = links || {};
    const showCta = Boolean(!!ctaLabel && (url || onClick));
    const fallbackAlt = alt || image?.description || "";
    const imageAlt = showCta ? "" : image?.description;
    return /* @__PURE__ */ React.createElement("div", { "data-t": "promotion-block", ref, className: classNames$1 }, manageContentButton, /* @__PURE__ */ React.createElement(ClickableImageWrapper, { url, ctaLabel, ariaLabel: fallbackAlt }, /* @__PURE__ */ React.createElement(
      Image,
      {
        url: imageUrl,
        "aria-hidden": !!url,
        alt: imageAlt,
        cover: true,
        className: "promotion-block__image"
      }
    )), /* @__PURE__ */ React.createElement("div", { className: "promotion-block__inner" }, (title || description) && /* @__PURE__ */ React.createElement("div", { className: "promotion-block__text", id: promotionInfoId }, title && /* @__PURE__ */ React.createElement(Heading, { component: "h2", variant: "medium", className: "promotion-block__title" }, title), description && /* @__PURE__ */ React.createElement(Text, { variant: "body", className: "promotion-block__subtitle" }, description)), showCta && /* @__PURE__ */ React.createElement(
      Button,
      {
        ...buttonStyles,
        className: "promotion-block__button",
        "data-t": "promotion-block-button",
        size: "custom",
        onClick,
        href: url,
        caption: ctaLabel,
        tabIndex
      }
    ), tooltip && tooltip.showTooltip && /* @__PURE__ */ React.createElement(BannerTooltip, { className: "promotion-block__tooltip", tooltip })));
  }
);
export {
  PromotionBlock
};
//# sourceMappingURL=PromotionBlock.js.map
